export default "__VITE_ASSET__Bvv3eGsF__"